var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticStyle:{"min-height":"100%"},attrs:{"max-width":""}},[_c('v-tabs',[_c('v-tab',{attrs:{"value":"0"}},[_vm._v("随访奖金审阅配置")])],1),_c('v-divider'),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('FollowUpBonusReviewSetting')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }